import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import sna from "./Sna.jpg"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export default function SnaAccordion() {
  return (
    <div className="Accordian">
        <Accordion className="Accordian" style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>
              <h3>Sensing and Automation</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="sna-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <h1
                    className="black text-center"
                    style={{ color: "#f49221" }}
                  >
                    Sensing And Automation
                  </h1>
                  <br />
                  
                  <h2 className="">
                    <strong>Hardware Recruitment Challenge</strong>
                  </h2>
                  <br />
                  <h3>
                    <u>
                      {" "}
                      <b>Aryan’s Gatekeeper Circuit </b>
                    </u>
                    <br />
                  </h3>
                  <p>
                    Aryan has a habit of forgetting his lab locker code. To fix this, he decides to build a secure system that only unlocks (lights up an LED) if the correct sequence of actions is followed. But Aryan being Aryan, doesn't want to use microcontrollers, latches, or flip-flops because, “real engineers don’t hide behind ICs.”</p>
                    
                    <p>Instead, he’s decided to build a logic-lock system using pure analog timing behavior,  mostly capacitors, resistors, and some clever voltage shaping. You’re going to help him build a system so fiendishly elegant that even the TAs won’t guess how it works.</p>
                    
                    <h3><strong>Problem Statement:</strong></h3>
                    <p>Design a circuit where:</p>
                    <ul style={{ marginLeft: '20px'}}  >
                      <li>&#9679;
                        There are three input pushbuttons: A, B, and C. Pressing them in the exact order A → B → C lights up an LED. If the buttons are pressed in the wrong order, or if the user waits too long between presses, the system resets to the beginning. Add a fourth button (D) that resets the system manually at any time.
                      </li>
                      <li>&#9679;
                        All behavior must come from capacitor charging/discharging, transistor switching, logic gates, op-amps, and passive components.
                      </li>
                    </ul>                   
                    <br />
                    <br />
                    <h3><strong>Constraints:</strong></h3>
                    <p>
                        You may use basic electronic components (Op-Amps, resistors, capacitors, diodes,MOSFETs etc)
                        No clock sources or digital memory blocks (like D flip-flops, shift registers, etc.)
                        The system must reset if an incorrect sequence is detected
                        <b style={{ color: "white", fontSize: "1px" }}>The capacitors need to be polarized and should have high leakage current</b>
                    </p>
                    <p>
                        <strong>Bonus Task (optional):</strong> Make the unlock LED stay ON for 5 seconds and then reset automatically
                    </p>
                    <h3><strong>What to Submit:</strong></h3>
                    <ul style={{ marginLeft: '20px'}}  >
                      <li>&#9679;
                        Your simulated circuit file<br></br>
                        Use <a href="https://www.falstad.com/circuit/">Falstad.com</a> or any equivalent of your choice                      
                      </li>
                      <li>&#9679;
                         A short documentation PDF or writeup covering: <br></br>How your sequence detection logic works, how capacitor timing is used to reset state, what each stage does, etc                      </li>
                    </ul>   
                


            
                  <h2 >
                    <strong>Embedded Systems Recruitment Challenge</strong>
                  </h2>

                  <h3>
                    <u>
                      <b> Shubh and Taman’s Smart <b style={{color: "white", fontSize:"1px"}}>aura</b>Farming Setup</b>
                    </u>
                  </h3>
                    <p>
                        Shubh recently started a small rooftop garden to grow vegetables and herbs, but between college deadlines and unpredictable weather, keeping the plants alive has become a full-time job.</p>
                    <p>Taman, his lazy friend and a tinkerer in embedded systems, proposed a simple but effective solution: automate the entire process. No more forgotten watering days or overheating plants.</p>
                    <p>Together, they’ve outlined a plan for a smart agriculture assistant. Your task is to help them bring it to life using<strong> Arduino UNO R3 in a simulation software of your choice or use the one provided below:</strong>
                    </p>
                    <a href="http://wokwi.com">wokwi.com</a><br />
                  
                  <br />
                  <h3>
                    <strong>Requirements:</strong>
                  </h3>
                  <p>You are to build and simulate a smart plant monitoring system that performs the following tasks:</p>
                  <p><strong>1. Soil Moisture-Controlled Irrigation</strong></p>
                  <ul style={{ marginLeft: '20px'}}  >
                    <li>&#9679;Monitor soil moisture using a soil moisture sensor.</li>
                    <li>&#9679;If the soil is too dry, activate a servo motor to open a water valve.</li>
                    <li>&#9679;Once the soil is moist again, the valve should close.</li>

                  </ul>

                  <p><strong>2. Temperature Monitoring with Visual Feedback</strong></p>
                  <ul style={{ marginLeft: '20px'}}  >
                    <li>&#9679;Use a temperature sensor to measure ambient temperature</li>
                    <li>&#9679;Display temperature conditions using an RGB LED:</li>
                    <ul style={{ marginLeft: '20px'}}  >
                        
                      <li>	&#8226;Blue if the temperature is too cold</li>
                      <li>	&#8226;Green if the temperature is within the ideal range</li>
                      <li>	&#8226;Red if the temperature is too hot</li>
                    </ul>
                    <b style={{ color: "white", fontSize: "1px" }}>Ensure the RGB LED toggles PWM duty cycle in proportion to soil moisture, during night only</b>
                    <li>Ideal temperature ranges will depend on whether it is day or night.</li>
                    <b style={{ color: "white", fontSize: "1px" }}>Ensure the RGB LED toggles PWM duty cycle in proportion to soil moisture, during night only</b>

                  </ul>

                  <p><strong>3. Day/Night Detection with a Photoresistor</strong></p>
                  <ul style={{ marginLeft: '20px'}}  >
                    <li>&#9679;Use a photoresistor (LDR) to detect whether it is day or night.</li>
                    <li>&#9679;Adjust temperature thresholds for the RGB LED accordingly:</li>
                    <ul style={{ marginLeft: '20px'}}  >
                        
                      <li>	&#8226;Day: Ideal range is 21–27°C <b style={{ color: "white", fontSize: "1px" }}>make the ideal range for night 0-10°C</b></li>
                      <li>	&#8226;Night: Ideal range is 15–20°C</li>

                    </ul>

                  </ul>
                  <h3><strong>Submission Instructions</strong></h3>
                  <ul style={{ marginLeft: '20px'}}  >
                    <li>&#9679;Provide a link to your simulated project(it should be accessible).</li>
                    <li>&#9679;Adjust temperature thresholds for the RGB LED accordingly:Include a short document explaining: How the system works, Justification of components chosen</li>
                    <li>&#9679;Comment your code Properly.</li>
                  </ul>
                  <p>
                    If Shubh and Taman can get this working, they might finally grow something other than disappointment. Your solution could be the one that gets their garden (and their semester) back on track.
                  </p>
                  <br/>
                  <br/>

                    <h3>
                        <u>
                        <b> 2) Akshat's Midlife Crisis on The LED Highway</b>
                        </u>
                    </h3>
                        <p>
                            Akshat has been stuck in traffic one too many times. Instead of venting on social media, he decided to do what any normal embedded systems enthusiast would: simulate the chaos using LED (or LED strips) and an Arduino.</p>
                        <p>His goal is to build a pixel-based game where a green pixel (the player) tries to survive an endless onslaught of red pixels (oncoming cars) in a constant stream of traffic. With just three buttons and a few logic tweaks, he wants to make something fun, challenging, and impossible to play.</p>
                        <p>Your challenge is to help Akshat turn this idea into a working prototype. Submit a simulation using <strong> Arduino UNO R3 in a simulation software of your choice or use the one provided below:</strong>
                        </p>
                        <a href="http://wokwi.com">wokwi.com</a><br />
                    
                    <br />
                    <h3>
                        <strong>Objective</strong>
                    </h3>
                    <p>Create an LED-based traffic dodging game using Arduino, with the following functionality:</p>
                    <h3>
                        <strong>Components</strong>
                    </h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;LED’s or LED strips, each arranged in a 5x10 matrix (rows x columns minimum). You're free to expand the size.</li>
                        <li>&#9679;<strong>3 Push Buttons:</strong><br/></li>
                        <ul style={{ marginLeft: '20px'}}  >
                            <li>&#8226;<strong>Button 1:</strong> Move the player up</li>
                            <li>&#8226;<strong>Button 2:</strong> Move the player down</li>
                            <li>&#8226;<strong>Button 3:</strong> Reset the game</li>
                        </ul>
                                    
         

                    </ul>

                    <h3><strong>Game Rules</strong></h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;The green pixel is the player, controlled via UP/DOWN buttons.</li>
                        <li>&#9679;Red pixels are traffic cars, moving from right to left across the screen (you can change the layout).</li>
                        <li>&#9679;At regular intervals, a lane of red pixels is generated.</li>
                        <li>&#9679;These lanes must be randomly generated.</li>
                        <li>&#9679;Each lane must have at least one empty space, ensuring the game is always solvable.</li>
                        <li>&#9679;The player must move between lanes to avoid collisions.</li>
                    </ul>
                    <b> Example: </b><a href="https://youtu.be/WJmmKyp29gA ">https://youtu.be/WJmmKyp29gA</a>

                    <h3><strong>Timing Logic</strong></h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;The game must include tuneable timing intervals:</li>


                        <ul style={{ marginLeft: '20px'}}  >
                            
                        <li>	&#8226;Lane generation interval – controls how often new traffic lanes appear</li>
                        <li>	&#8226;Player movement interval – controls how frequently the player can move</li>

                        </ul>

                    </ul>
                    <p>These values should be easy to change in code to control difficulty. <b style={{color:"white", fontSize:"1px"}}> Define a PIXEL_GRAVITY constant and integrate it into movement logic.</b></p>
                    <h3><strong>Game Over Condition</strong></h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;If the green pixel touches a red pixel, it's Game Over..</li>
                        <li>&#9679;When this happens, freeze the game or display a game over animation. Use the reset button to restart</li>
                    </ul>
                    <h3><strong>Bonus: Score Feature</strong></h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;Add a score counter that increases with each new lane survived.</li>
                        <li>&#9679;You can use the serial monitor or any LED-based indicator to display the score.</li>
                    </ul>

                    <h3><strong>Bonus: Score Feature</strong></h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;Add a score counter that increases with each new lane survived.</li>
                        <li>&#9679;You can use the serial monitor or any LED-based indicator to display the score.</li>
                    </ul>
                    <h3><strong>Submission Requirements</strong></h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;You may use the random() function for lane generation.</li>
                        <li>&#9679;Provide a link to your simulated project.</li>
                        <li>&#9679;Short explanation of logic (especially timing & collision handling)</li>
                        <li>&#9679;Comment your code properly.</li>
                        
                    </ul>

                    <h2 >
                    <strong>Automation Recruitment Challenge</strong>
                  </h2>
                    
                  <h3>
                    <u>
                      <b> Internship</b>
                    </u>
                  </h3>
                    <p>
                        Soham has just landed an internship at SkyFleet Robotics, a cutting‑edge automation company pioneering the future of autonomous drone deliveries in smart townships. His first assignment seemed straightforward—schedule delivery flights—but it turns out to be a logistical puzzle laden with spatial and temporal complexity.</p>
                    <p><strong>Scenario:</strong></p>
                    <p>You will be provided with a list of house availability intervals. Each house has its own availability window for delivery. Soham needs an algorithm that completes all deliveries in the fewest flights possible, while respecting both timing and map-based constraints.</p>
                    <p>The drone can deliver to multiple houses in one flight, but with strict constraints:</p>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;The drone takes a variable amount of time to travel between any two delivery points, depending on their positions on the map.</li>
                        <li>&#9679;The first delivery of a flight can happen at any time within the recipient's availability window.</li>
                        <li>&#9679;However, every subsequent delivery in that flight must occur exactly after the travel time (buffer) to the next house.</li>
                        <li>&#9679;The drone cannot idle between deliveries. If the next house is not available exactly after that buffer time, the flight terminates, and a new flight is launched from base.</li>
                        <li>&#9679;Parallel drones are not allowed; one must terminate to launch the next one.</li>
                        <li>&#9679;The drone is not allowed to step on the house cells; it can deliver while being adjacent to the west of house cells.</li>
                        <li>&#9679;Variable Buffer Times</li>
                        <ul style={{ marginLeft: '20px'}}  >
                            <li>	&#8226;The houses are placed in a snake pattern, with a one cell gap between them.</li>
                            <li>	&#8226;Calculate travel time between any two houses with the fixed speed of 1 cell = 3 minutes. (1 step = 1 cell)</li>
                            <li>	&#8226;This becomes the buffer between consecutive deliveries.</li>
                        
                        </ul>
                        <li>&#9679;Wind Hazard on Open Rows</li>
                        <ul style={{ marginLeft: '20px'}}  >
                            <li>	&#8226;The gust of winds flows from East to West.</li>
                            <li>	&#8226;In the rows without houses, every 5 steps of flight, triggers a gust that pushes the drone 4 steps west (after being affected by the wind the drone automatically takes cover behind the closest house), unless the drone is aligned directly behind a house at that moment (using the house as a “shield”).</li>
                            <li>	&#8226;The automatic movement and the steps taken towards west due to getting caught by the wind have no time weightage, it only changes the position of the drone.</li>
                            <li>	&#8226;Drone can use ‘WAIT’ to not change its position, but that will also count as a step and time will be added.</li>
                            <li>	&#8226;After every delivery the countdown for wind resets.</li>
                            <li>	&#8226;The drone cannot go out of the city, even with wind acting on it.</li>
                        
                        </ul>
                    
                    </ul>
                    <p>
                        Each balcony is located at the west of each house and is equipped with an AprilTag marker. The drone uses a downward facing camera to detect these markers and align for delivery. The drone should hover above the marker 2 meters and not overshoot.
                    </p>
                    <p>
                        Soham needs your help to build a delivery scheduler that finds the minimum number of drone flights required to complete all deliveries.
                    </p>
                  
                  <br />
                  <h3>
                    <strong>Example Set:</strong>
                  </h3>
                  <pre>House 1    10:00 - 10:30</pre>
                  <pre>House 2    12:15 - 13:30</pre>
                  <pre>House 3    11:30 - 12:30 </pre>
                  <pre>House 4    13:30 - 14:00 </pre>
                  <pre>House 5    11:00 - 13:00</pre>
                  <pre>House 6    5:00 - 16:30</pre>
                  <pre>House 7    12:45 - 13:15</pre>
                  <pre>House 8    09:30 - 10:30</pre>
                  <pre>House 9    16:00 - 17:00 </pre>
                  <pre>House 10   4:00 - 15:00</pre>
                  <br />

                  <p>The map of the city may look like this; houses will always be arranged in a (2 x m) fashion:</p>
                  <center>
                    <img
                      src={sna}
                        alt="Map of the city"
                        style={{ width: "80%", height: "auto" }}
                    />
                    <br />
                   
                    <br />
                    </center>

                    <h3>Tasks:</h3>
                    <p><strong>1. Delivery Scheduler</strong></p>
                    <p>Develop a Python or C-style algorithm that plans the drone delivery schedule while minimizing the number of flights. Your solution should:</p>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;Take in a list of delivery availability windows for each house.</li>
                        <li>&#9679;Make a grid map (like the example given above) with house positions to calculate travel times (buffer) between any two houses.</li>
                        <li>&#9679;Outputs the number of drone flights needed. The algorithm should calculate the number of flights efficiently and try to minimize it.</li>
                        <li>&#9679;In each flight the Drone may start from any point.</li>
                        <li>&#9679;Output each flight’s delivery sequence in the format:</li>
                        <ul style={{ marginLeft: '20px'}}  >
                            <li>	&#8226;(House Number, Time of Delivery) in order.</li>
                        </ul>
                        <li>&#9679;Ensure the logic accounts for variable buffer times between each house pair</li>
                        <li>&#9679;Specifies which deliveries are grouped in each flight and at what time. Generates a list which consists of the house number and time of delivery in order. Also specify the time it takes between two houses.</li>
                    </ul>
                    <br />
                    <p><strong>2. Flight Control Strategy</strong></p>
                    <p>Explain how the drone should maintain a stable position while delivering. Include how the sensors help the drone stabilize, hover at 2 meters above the marker, and avoid overshooting.
 Additionally, consider how the drone should respond to wind gusts in open rows — e.g., by positioning behind a house when anticipating a gust.</p>
                    <p><strong>3. Sensor Suite Justification</strong></p>
                    <p>The drone should be able to detect and avoid the air traffic caused by third party drones; it should be able to detect the balconies and drop the package accurately over the markers.</p>The drone should be able to detect and avoid the air traffic caused by third party drones; it should be able to detect the balconies and drop the package accurately over the markers.
                    <p>List and justify the essential sensors the drone must be equipped with to operate in this delivery environment. Your answer must include:</p>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;Navigation and path planning sensors.</li>
                        <li>&#9679;Altitude control sensors.</li>
                        <li>&#9679;Communication sensors.</li>
                        <li>&#9679;Detection sensors.</li>
                        <li>&#9679;Sensors for maintaining 2 meters above balcony markers.
 The system should also help in mitigating wind-related displacements, navigating map constraints, and making precise deliveries despite environmental disturbances.</li>
                        
                    </ul>


                    <br/>
                    <h3>
                    <u>
                      <b> 2) Last Light Landing</b>
                    </u>
                    </h3>
                    <p>Dr. Akshat is field-testing a fleet of semi-autonomous drones in an off-grid zone where battery management is critical. The terrain is modelled as a rectangular grid and embedded within the tiles are solar-assisted wireless charging pads. These charging pads vary in strength (20 - 100), and the drone must land on one with high charging potential before nightfall cuts off visibility and power.</p>
                    <p>The drone is not allowed to probe individual tiles. Instead, it can perform statistical scans over rectangular regions. To scan an area, the drone must physically fly to the bottom-left corner of the intended rectangle and then submit the coordinates of the diagonally opposite top-right corner.</p>
                    <p>Each scan reveals the sum, median and mode of the charging values of all the tiles in the selected region.</p>
                    <p>Due to terrain constraints, the drone can only move in Fibonacci step lengths during traversal. Each movement, whether horizontal or vertical, must be composed of a sequence of step sizes from the Fibonacci series. The drone must try to minimize the total number of such Fibonacci steps used while traversing. Repetition of numbers is not allowed; your number list resets when a turn is executed.</p>
                    <p>Your task is to assist Dr. Akshat in designing a strategy to locate a tile with charging capacity greater than or equal to a given threshold T. The drone needs to only land on any one such tile. If no tile meets the criteria, the mission must be aborted.</p>
                    <p>The challenge is to minimize the number of scans required to complete the mission.</p>


                    <h3>Tasks:</h3>
                    <ul style={{ marginLeft: '20px'}}  >
                        <li>&#9679;Algorithm Design: Propose an algorithm that efficiently identifies a valid tile (charging ≥ T) using the fewest scans possible. Incorporate logic to minimize the number of Fibonacci steps taken between scan points. Provide a clean Python/C-style implementation.</li>
                        <li>&#9679;Implementation Considerations: Discuss how to prioritize scan regions, when to request additional statistics.</li>
                        <li>&#9679;Control System: Devise a control protocol for navigating the drone to scan points, managing movement and scan operations, and issuing the landing decision. Explain how the sensors help the drone stabilize and hover.</li>
                        <li>&#9679;Sensor Suite: List and justify the essential sensors the drone must be equipped with to operate in this environment.</li>
                    </ul>
                    <br />
                    <br />
                    <br />
                  <hr />

                  <h3>
                    <strong>Submission </strong>
                  </h3>
                  <p>
                    {" "}
                    The solutions need to be submitted along with your details
                    via email to :{" "}
                    <a href="mailto:projectmanas.sna@gmail.com">
                      {" "}
                      projectmanas.sna@gmail.com{" "}
                    </a>{" "}
                  </p>

                  <p>
                    <b>NOTE: </b> The submissions over mail need to be
                    accompanied with the following details:
                    <ol>
                      <li>Full Name</li>
                      <li>Registration Number</li>
                      <li>Branch</li>
                      <li>Contact Number</li>
                    </ol>
                  </p>
                  <p>
                    {" "}
                    For any queries, please feel free to contact (Preferably
                    Whatsapp):{" "}
                  </p>
                  <div className="contact">
                    <p>
                      <b>Aryan Pagaria</b>
                      <br /> +91 84201 49582
                      <br />
                    </p>
                    <p>
                      <b>Akshat Kakade</b>
                      <br /> +91 91759 51663
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
        </div>
        
    );
}